import { Route, Navigate } from "react-router-dom";
import {
  CLIENT_TYPES,
  ENTITY_ROUTES,
  ENTITY_ROUTES_SP,
  INCOMPLETE_CONFIG,
} from "../utils/constants";
import MetricsDashboard from "../pages/MetricsDashboard";
import AccountDetails from "../pages/account/AccountDetails";
import NotificationComponent from "../pages/Notifications";
import NotFound from "../pages/NotFound";
import InitialConfiguration from "../pages/configuration/initial/V2/InitialConfiguration";
import InitialConfigSuccess from "../pages/configuration/InitialConfigSuccess";
import MainLayout from "../components/MainLayout";
import ImpersonateWrapper from "../components/ImpersonateWrapper";
import { IPrivateRoutes } from "../interfaces/routes";
import { getRouteSetByPermission } from "../utils/routes";
import UserDetails from "../pages/account/UserDetails";

export const privateRoutes = ({
  entity,
  rules,
  planName,
  initialConfigurationComplete,
  permissions,
}: IPrivateRoutes) => (
  <>
    {CLIENT_TYPES.includes(entity) &&
     initialConfigurationComplete === INCOMPLETE_CONFIG && (
      <>
        <Route
          path={`configuracion-inicial-${ENTITY_ROUTES_SP[entity]}`}
          element={
            <ImpersonateWrapper>
              <InitialConfiguration />
            </ImpersonateWrapper>
          }
        />
        <Route
          path={`configuracion-inicial-${ENTITY_ROUTES_SP[entity]}-exitosa`}
          element={
            <ImpersonateWrapper>
              <InitialConfigSuccess />
            </ImpersonateWrapper>
          }
        />
      </>
    )}
    {entity && permissions ? (
      <>
        <Route path={ENTITY_ROUTES[entity]} element={<MainLayout />}>
          {/* Inicio renderiza el dashboard de métricas solo para los clientes
              habilitados (ver METRICS_DASHBOARD_ENABLED_CLIENTS). Para el resto
              (p.ej. macropremia, sin backend de métricas) cae a la Home
              anterior en vez de romper el Inicio. */}
          <Route index element={<MetricsDashboard />} />
          <Route path="cuenta" element={<AccountDetails />} />
          <Route path="mis-datos" element={<UserDetails />} />
          <Route path="notificaciones" element={<NotificationComponent />} />
          {Object.entries(permissions).map(([name, values]) =>
            getRouteSetByPermission({
              permission: { name, values },
              entity,
              rules,
              planName,
            })
          )}
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={ENTITY_ROUTES[entity]} replace />}
        />
      </>
    ) : (
      <Route path="*" element={<MainLayout />} />
    )}
  </>
);
